import get from "lodash/get";
import { ComponentCutomizedStyles, mediaBreakpointDown, mediaBreakpointUp, mergeWithComponentCustomizedStyles, sizes } from 'conversional-theme';
import { generateClasses } from '../../../utilities/components/styles';
var generateStyles = function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    return (mergeWithComponentCustomizedStyles(theme, "consultantBox", {
        container: (_a = {
                display: 'flex',
                justifyContent: 'start',
                marginTop: "2rem",
                position: 'relative'
            },
            _a[mediaBreakpointUp(sizes.md)] = {
                marginTop: 100
            },
            _a),
        containerTop: (_b = {
                display: 'flex',
                justifyContent: 'start',
                marginTop: "2rem",
                marginLeft: 10,
                marginRight: 10,
                position: 'relative',
                flexDirection: 'column',
                alignItems: 'center'
            },
            _b[mediaBreakpointDown(sizes.xs)] = {
                marginBottom: 10,
            },
            _b),
        topAvatarContainer: (_c = {
                flexDirection: "column",
                alignItems: "center"
            },
            _c[mediaBreakpointUp(sizes.md)] = {
                marginTop: 30
            },
            _c),
        textBoxContainer: (_d = {},
            _d[mediaBreakpointUp(sizes.md)] = {
                marginRight: theme.spaces.desktop.m
            },
            _d.marginLeft = theme.spaces.desktop.m,
            _d.position = 'relative',
            _d.width = '100%',
            _d),
        textBoxContainerTop: (_e = {
                position: 'relative',
                width: '100%',
                marginBottom: theme.spaces.desktop.m,
                marginLeft: 0,
                marginRight: 0,
                marginTop: theme.spaces.desktop.m
            },
            _e[mediaBreakpointDown(sizes.xs)] = {
                marginBottom: 25
            },
            _e),
        caret: (_f = {
                backgroundColor: get(ComponentCutomizedStyles((_p = (_o = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _o === void 0 ? void 0 : _o.elements) === null || _p === void 0 ? void 0 : _p.textbox), 'backgroundColor', theme.colors.surface_dark),
                height: 15,
                left: -7,
                position: 'absolute',
                top: 30,
                transform: 'rotate(45deg)',
                width: 15
            },
            _f[mediaBreakpointDown(sizes.sm)] = {
                top: 10
            },
            _f),
        caretTop: {
            backgroundColor: get(ComponentCutomizedStyles((_r = (_q = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _q === void 0 ? void 0 : _q.elements) === null || _r === void 0 ? void 0 : _r.textbox), 'backgroundColor', theme.colors.surface_dark),
            height: 15,
            position: 'absolute',
            transform: 'rotate(45deg)',
            width: 15,
            top: -7,
            left: 'calc(50% - 7.5px)'
        },
        avatar: (_g = {},
            _g[mediaBreakpointUp(sizes.md)] = {
                // position: 'absolute',
                top: 0,
                width: 100,
                textAlign: 'center'
            },
            _g[mediaBreakpointDown(sizes.sm)] = {
                textAlign: 'left'
            },
            _g.color = get(ComponentCutomizedStyles((_t = (_s = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _s === void 0 ? void 0 : _s.elements) === null || _t === void 0 ? void 0 : _t.textbox), 'color', theme.colors.carbon_dark),
            _g.alignItems = 'center',
            _g.display = 'flex',
            _g.flexDirection = 'column',
            _g.justifyContent = 'start',
            _g.width = 80,
            _g),
        avatarTop: {
            position: 'relative',
            width: '100%',
            textAlign: 'center',
            color: get(ComponentCutomizedStyles((_v = (_u = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _u === void 0 ? void 0 : _u.elements) === null || _v === void 0 ? void 0 : _v.textbox), 'color', theme.colors.carbon_dark),
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start'
        },
        avatarMobile: (_h = {},
            _h[mediaBreakpointDown(sizes.xs)] = {
            // width: 60,
            },
            _h),
        belowAvatar: (_j = {},
            _j[mediaBreakpointDown(sizes.xs)] = {
                display: 'none'
            },
            _j),
        description: (_k = {
                textAlign: 'center'
            },
            _k[mediaBreakpointUp(sizes.xs)] = {
                display: 'none',
            },
            _k.fontSize = theme.typo.sizes.xs,
            _k.fontFamily = theme.typo.fonts.bold,
            _k.marginBottom = 5,
            _k),
        name: {
            fontSize: theme.typo.sizes.s,
            fontFamily: theme.typo.fonts.bold
        },
        role: (_l = {
                fontSize: theme.typo.sizes.s
            },
            _l[mediaBreakpointDown(sizes.sm)] = {
                fontSize: theme.typo.sizes.xs,
                fontFamily: theme.typo.fonts.regular
            },
            _l),
        img: (_m = {
                margin: '0 auto',
                borderRadius: get(ComponentCutomizedStyles((_x = (_w = theme === null || theme === void 0 ? void 0 : theme.customizedStyles) === null || _w === void 0 ? void 0 : _w.elements) === null || _x === void 0 ? void 0 : _x.textbox), 'borderRadius', '50%'),
                marginBottom: theme.spaces.desktop.xs,
                width: 100,
                textAlign: 'center',
                objectFit: 'cover'
            },
            _m[mediaBreakpointDown(sizes.xs)] = {
                margin: 0
            },
            _m),
        avatarTopImg: {},
    }));
};
export var renderClasses = generateClasses(generateStyles);
